import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IVesselsExportLoading,
  IVesselsExportLoadingInitialState,
} from "./vesselsExportLoadingModel";
import {
  getAllVesselsExportLoading,
  createVesselsExportLoading,
  deleteVesselsExportLoading,
  getVesselsExportLoadingByID,
  updateVesselsExportLoading,
} from "./services/vesselsExportLoading.services";

const initialState: IVesselsExportLoadingInitialState = {
  loading: false,
  error: "",
  FilterCustomVEL: {
    vessels_name: "",
  },
  VesselsExportLoadingID: null,
  VesselsExportLoadingGUID: "",
  VesselsExportLoadingList: [],
  VesselsExportLoadingDetail: {
    at_jetty: "",
    eta: "",
    etd: "",
    vessels_name: "",
    agent_id: "",
    cargo: "",
    next_port_id: null,
    // form_type: "",
  },
};

const vesselsExportLoadingSlice = createSlice({
  name: "vesselsExportLoading",
  initialState,
  reducers: {
    clearVesselsExportLoadingDetails: (state) => {
      state.VesselsExportLoadingDetail =
        initialState.VesselsExportLoadingDetail;
    },
    setVesselsExportLoadingID: (state, action) => {
      state.VesselsExportLoadingID = action.payload;
    },
    clearVesselsExportLoadingID: (state) => {
      state.VesselsExportLoadingID = initialState.VesselsExportLoadingID;
    },
    setVesselsExportLoadingGUID: (state, action) => {
      state.VesselsExportLoadingGUID = action.payload;
    },
    clearVesselsExportLoadingGUID: (state) => {
      state.VesselsExportLoadingGUID = initialState.VesselsExportLoadingGUID;
    },
    setFilterCustomVEL: (state, action) => {
      state.FilterCustomVEL = action.payload;
    },
    clearFilterCustomVEL: (state) => {
      state.FilterCustomVEL = initialState.FilterCustomVEL;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllVesselsExportLoading.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllVesselsExportLoading.fulfilled,
      (state, action: PayloadAction<IVesselsExportLoading[]>) => {
        state.loading = false;
        state.VesselsExportLoadingList = action.payload || [];
      }
    );
    builder.addCase(getAllVesselsExportLoading.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.VesselsExportLoadingList = [];
    });

    builder.addCase(createVesselsExportLoading.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createVesselsExportLoading.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createVesselsExportLoading.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateVesselsExportLoading.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateVesselsExportLoading.fulfilled, (state) => {
      state.loading = true;
    });
    builder.addCase(updateVesselsExportLoading.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteVesselsExportLoading.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteVesselsExportLoading.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteVesselsExportLoading.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getVesselsExportLoadingByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getVesselsExportLoadingByID.fulfilled,
      (state, action: any) => {
        state.loading = false;
        state.VesselsExportLoadingDetail = action.payload;
      }
    );
    builder.addCase(getVesselsExportLoadingByID.rejected, (state, action) => {
      state.loading = false;
      state.VesselsExportLoadingDetail =
        initialState.VesselsExportLoadingDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearVesselsExportLoadingDetails,
  clearVesselsExportLoadingID,
  setVesselsExportLoadingID,
  clearVesselsExportLoadingGUID,
  setVesselsExportLoadingGUID,
  setFilterCustomVEL,
  clearFilterCustomVEL,
} = vesselsExportLoadingSlice.actions;
export default vesselsExportLoadingSlice.reducer;
